export const translations = {
  "en": {
    "languageName": "English",
    "title": "Star Wander - Starry Sky in Your Hand",
    "appName": "Star Wander",
    "navFeatures": "Features",
    "navFaq": "FAQ",
    "navDownload": "Download",
    "heroTitle": "Starry Sky in Your Hand",
    "heroSubtitle": "Explore the stars, planets, and constellations in real-time. Start your cosmic journey!",
    "downloadAppStore": "App Store",
    "downloadGooglePlay": "Google Play",
    "downloadHarmony": "App Gallery",
    "downloadApk": "Download Apk",
    "featuresTitle": "Key Features",
    "feature1Title": "Time Travel",
    "feature1Desc": "Jump to any moment to observe the sky of the past or future.",
    "feature2Title": "Stargazing Guide",
    "feature2Desc": "Smartly identify visible celestial bodies for tonight's observation.",
    "feature3Title": "Astro Calendar",
    "feature3Desc": "Predict meteor showers and eclipses to catch every cosmic event.",
    "feature4Title": "Smart Search",
    "feature4Desc": "Locate stars and constellations instantly with a high-speed engine.",
    "feature5Title": "Deep Exploration",
    "feature5Desc": "Unlock a detailed knowledge base by simply touching any star.",
    "faqTitle": "Frequently Asked Questions",
    "faq1Q": "What languages does Star Wander support?",
    "faq1A": "Star Wander supports 10+ languages including English, Chinese (Simplified & Traditional), Japanese, Korean, French, German, Spanish, Italian, Portuguese, and Russian.",
    "faq2Q": "Does the app require an internet connection?",
    "faq2A": "A stable internet connection is recommended for the best experience, but basic star chart viewing works offline after initial data download.",
    "faq3Q": "Is Star Wander completely free?",
    "faq3A": "Star Wander is free to download with basic features available at no cost. Premium membership unlocks the complete Messier catalog, over 2.5 million stars from the Star Valley Second Catalog, and field of view simulation.",
    "faq4Q": "Which devices are supported?",
    "faq4A": "Star Wander is available on both iOS (iPhone & iPad) and Android devices. We recommend devices with iOS 17+ or Android 10+ for optimal performance.",
    "faq5Q": "How accurate is the star tracking?",
    "faq5A": "Star Wander uses precise astronomical algorithms with data from major star catalogs. The accuracy is within arcsecond precision for celestial object positioning.",
    "ctaSubtitle": "Start Your Journey",
    "ctaTitle1": "Ready to Explore",
    "ctaTitle2": "the Universe?",
    "ctaDesc": "Point your device at the sky and discover a universe of wonders — no telescope required.",
    "ctaBtnAppStore": "Download on App Store",
    "ctaBtnGooglePlay": "Get it on Google Play",
    "ctaFooter": "Free to download. No ads. No subscription required.",
    "stat1": "Constellations",
    "stat2": "Global Users",
    "stat3": "Events / Year",
    "stat4": "Free to Use",
    "footerCopy": "All Rights Reserved.",
    "userAgreement": "Terms of Service",
    "privacyPolicy": "Privacy Policy",
    "androidSuffix": "(Android)",
    "iOSSuffix": "(iOS)"
  },
  "zh-cn": {
    "languageName": "简体中文",
    "title": "Star Wander - 您的掌上星空",
    "appName": "Star Wander",
    "navFeatures": "功能",
    "navFaq": "常见问题",
    "navDownload": "下载",
    "heroTitle": "您的掌上星空",
    "heroSubtitle": "只需将设备对准天空，即可实时探索星星、行星和星座。即刻开启您的宇宙漫游之旅！",
    "downloadAppStore": "App Store",
    "downloadGooglePlay": "Google Play",
    "downloadHarmony": "华为应用市场",
    "downloadApk": "下载安卓安装包",
    "featuresTitle": "核心功能",
    "feature1Title": "穿越时空",
    "feature1Desc": "自由跳转任意时刻，观察过去与未来的星象变幻。",
    "feature2Title": "观星指南",
    "feature2Desc": "智能指引今晚可见星体，您的专属夜空观测助手。",
    "feature3Title": "天文日历",
    "feature3Desc": "精准预测流星雨、月食等奇观，锁定每一场宇宙盛宴。",
    "feature4Title": "智能搜索",
    "feature4Desc": "毫秒级索引引擎，助您在浩瀚星海中瞬间定位目标。",
    "feature5Title": "深度探索",
    "feature5Desc": "触碰星体解锁详尽知识库，让天文百科触手可及。",
    "faqTitle": "常见问题",
    "faq1Q": "Star Wander 支持哪些语言？",
    "faq1A": "Star Wander 支持 10 多种语言，包括英语、简体中文、繁体中文、日语、韩语、法语、德语、西班牙语、意大利语、葡萄牙语和俄语。",
    "faq2Q": "应用需要联网才能使用吗？",
    "faq2A": "建议在有稳定网络连接时获得最佳体验，但初始数据下载后，基本的星图查看功能可离线使用。",
    "faq3Q": "Star Wander 完全免费吗？",
    "faq3A": "Star Wander 基础功能免费，会员订阅可解锁完整的梅西耶天体目录、超过 250 万颗恒星的星谷第二星表以及视场模拟功能。",
    "faq4Q": "支持哪些设备？",
    "faq4A": "Star Wander 支持 iOS（iPhone 和 iPad）以及 Android 设备。建议使用 iOS 17+ 或 Android 10+ 以获得最佳性能。",
    "faq5Q": "星体追踪的精度如何？",
    "faq5A": "Star Wander 使用精确的天文算法，数据来自主要星表。天体定位精度达到角秒级别。",
    "ctaSubtitle": "开启你的旅程",
    "ctaTitle1": "准备好探索",
    "ctaTitle2": "宇宙了吗？",
    "ctaDesc": "将您的设备对准天空，发现一个充满奇迹的宇宙——无需望远镜。",
    "ctaBtnAppStore": "在 App Store 下载",
    "ctaBtnGooglePlay": "在 Google Play 获取",
    "ctaFooter": "免费下载。无广告。无需订阅。",
    "stat1": "星座数量",
    "stat2": "全球用户",
    "stat3": "年度事件",
    "stat4": "完全免费",
    "footerCopy": "版权所有.",
    "userAgreement": "用户协议",
    "privacyPolicy": "隐私政策",
    "androidSuffix": "(安卓)",
    "iOSSuffix": "(iOS)"
  },
  "zh-tw": {
    "languageName": "繁體中文",
    "title": "Star Wander - 您的掌上星空",
    "appName": "Star Wander",
    "navFeatures": "功能",
    "navFaq": "常見問題",
    "navDownload": "下載",
    "heroTitle": "您的掌上星空",
    "heroSubtitle": "只需將設備對準天空，即可實時探索星星、行星和星座。即刻開啟您的宇宙漫遊之旅！",
    "downloadAppStore": "App Store",
    "downloadGooglePlay": "Google Play",
    "downloadHarmony": "App Gallery",
    "downloadApk": "下載安卓安裝包",
    "featuresTitle": "核心功能",
    "feature1Title": "穿越時空",
    "feature1Desc": "自由跳轉任意時刻，觀察過去與未來的星象變幻。",
    "feature2Title": "觀星指南",
    "feature2Desc": "智能指引今晚可見星體，您的專屬夜空觀測助手。",
    "feature3Title": "天文日曆",
    "feature3Desc": "精準預測流星雨、月食等奇觀，鎖定每一場宇宙盛宴。",
    "feature4Title": "智能搜索",
    "feature4Desc": "毫秒級索引引擎，助您在浩瀚星海中瞬間定位目標。",
    "feature5Title": "深度探索",
    "feature5Desc": "觸碰星體解鎖詳盡知識庫，讓天文百科觸手可及。",
    "faqTitle": "常見問題",
    "faq1Q": "Star Wander 支援哪些語言？",
    "faq1A": "Star Wander 支援 10 多種語言，包括英語、簡體中文、繁體中文、日語、韓語、法語、德語、西班牙語、義大利語、葡萄牙語和俄語。",
    "faq2Q": "應用需要連網才能使用嗎？",
    "faq2A": "建議在有穩定網路連線時獲得最佳體驗，但初始資料下載後，基本的星圖查看功能可離線使用。",
    "faq3Q": "Star Wander 完全免費嗎？",
    "faq3A": "Star Wander 基礎功能免費，會員訂閱可解鎖完整的梅西耶天體目錄、超過 250 萬顆恆星的星谷第二星表以及視場模擬功能。",
    "faq4Q": "支援哪些設備？",
    "faq4A": "Star Wander 支援 iOS（iPhone 和 iPad）以及 Android 設備。建議使用 iOS 17+ 或 Android 10+ 以獲得最佳效能。",
    "faq5Q": "星體追蹤的精度如何？",
    "faq5A": "Star Wander 使用精確的天文演算法，資料來自主要星表。天體定位精度達到角秒級別。",
    "ctaSubtitle": "開啟你的旅程",
    "ctaTitle1": "準備好探索",
    "ctaTitle2": "宇宙了嗎？",
    "ctaDesc": "將您的設備對準天空，發現一個充滿奇蹟的宇宙——無需望遠鏡。",
    "ctaBtnAppStore": "在 App Store 下載",
    "ctaBtnGooglePlay": "在 Google Play 獲取",
    "ctaFooter": "免費下載。無廣告。無需訂閱。",
    "stat1": "星座數量",
    "stat2": "全球用戶",
    "stat3": "年度事件",
    "stat4": "完全免費",
    "footerCopy": "版權所有.",
    "userAgreement": "使用者協議",
    "privacyPolicy": "隱私權政策",
    "androidSuffix": "(安卓)",
    "iOSSuffix": "(iOS)"
  },
  "ja": {
    "languageName": "日本語",
    "title": "Star Wander - 手のひらに星空を",
    "appName": "Star Wander",
    "navFeatures": "機能",
    "navFaq": "FAQ",
    "navDownload": "ダウンロード",
    "heroTitle": "手のひらに星空を",
    "heroSubtitle": "リアルタイムで星、惑星、星座を探索しましょう。宇宙の旅を始めよう！",
    "downloadAppStore": "App Store",
    "downloadGooglePlay": "Google Play",
    "downloadHarmony": "App Gallery",
    "downloadApk": "Apkをダウンロード",
    "featuresTitle": "主な機能",
    "feature1Title": "タイムトラベル",
    "feature1Desc": "過去や未来の任意の時刻にジャンプして星空を観察。",
    "feature2Title": "観測ガイド",
    "feature2Desc": "今夜見える天体をスマートに案内。あなたの観測アシスタント。",
    "feature3Title": "天文カレンダー",
    "feature3Desc": "流星群や月食を正確に予測。宇宙のイベントを逃さない。",
    "feature4Title": "スマート検索",
    "feature4Desc": "ミリ秒単位の検索で、広大な星海から目標を即座に特定。",
    "feature5Title": "ディープ探索",
    "feature5Desc": "天体に触れるだけで詳細な知識ベースをアンロック。",
    "faqTitle": "よくある質問",
    "faq1Q": "Star Wanderはどの言語をサポートしていますか？",
    "faq1A": "Star Wanderは英語、中国語（簡体字・繁体字）、日本語、韓国語、フランス語、ドイツ語、スペイン語、イタリア語、ポルトガル語、ロシア語を含む10以上の言語をサポートしています。",
    "faq2Q": "アプリの使用にインターネット接続は必要ですか？",
    "faq2A": "最良の体験には安定したインターネット接続をおすすめしますが、初期データダウンロード後は基本的な星図表示をオフラインで使用できます。",
    "faq3Q": "Star Wanderは完全無料ですか？",
    "faq3A": "Star Wanderは基本機能は無料でお使いいただけます。プレミアムメンバーシップで、メシエカタログ完全版、Star Valley Second Catalogの250万以上の星、視野シミュレーションが利用可能です。",
    "faq4Q": "どのデバイスをサポートしていますか？",
    "faq4A": "Star WanderはiOS（iPhone・iPad）およびAndroidデバイスでご利用いただけます。最適なパフォーマンスのためにiOS 17+またはAndroid 10+をおすすめします。",
    "faq5Q": "星の追跡精度はどのくらいですか？",
    "faq5A": "Star Wanderは主要な星表からのデータを使用した精密な天文アルゴリズムを採用しています。天体位置の精度は秒角レベルです。",
    "ctaSubtitle": "旅を始めよう",
    "ctaTitle1": "さあ、宇宙を",
    "ctaTitle2": "探索しよう",
    "ctaDesc": "デバイスを空に向けて、望遠鏡なしで宇宙の驚異を発見しましょう。",
    "ctaBtnAppStore": "App Storeからダウンロード",
    "ctaBtnGooglePlay": "Google Playで入手",
    "ctaFooter": "無料ダウンロード。広告なし。サブスクリプション不要。",
    "stat1": "星座数",
    "stat2": "世界のユーザー",
    "stat3": "年間イベント",
    "stat4": "完全無料",
    "footerCopy": "全著作権所有.",
    "userAgreement": "利用規約",
    "privacyPolicy": "プライバシーポリシー",
    "androidSuffix": "(Android)",
    "iOSSuffix": "(iOS)"
  },
  "it": {
    "languageName": "Italiano",
    "title": "Star Wander - Il cielo stellato nel palmo della tua mano",
    "appName": "Star Wander",
    "navFeatures": "Funzionalità",
    "navFaq": "FAQ",
    "navDownload": "Scarica",
    "heroTitle": "Il cielo stellato nel palmo della tua mano",
    "heroSubtitle": "Esplora stelle, pianeti e costellazioni in tempo reale. Inizia il tuo viaggio cosmico!",
    "downloadAppStore": "App Store",
    "downloadGooglePlay": "Google Play",
    "downloadHarmony": "App Gallery",
    "downloadApk": "Scarica Apk",
    "featuresTitle": "Funzionalità principali",
    "feature1Title": "Viaggio nel Tempo",
    "feature1Desc": "Salta in qualsiasi momento per osservare il cielo passato o futuro.",
    "feature2Title": "Guida Astronomica",
    "feature2Desc": "Identifica i corpi celesti visibili stasera in modo intelligente.",
    "feature3Title": "Calendario Astro",
    "feature3Desc": "Prevedi sciami meteorici ed eclissi per ogni evento cosmico.",
    "feature4Title": "Ricerca Rapida",
    "feature4Desc": "Localizza stelle e costellazioni all'istante con un motore veloce.",
    "feature5Title": "Esplorazione",
    "feature5Desc": "Tocca i corpi celesti per scoprire un database dettagliato.",
    "faqTitle": "Domande Frequenti",
    "faq1Q": "Quali lingue supporta Star Wander?",
    "faq1A": "Star Wander supporta oltre 10 lingue, tra cui inglese, cinese (semplificato e tradizionale), giapponese, coreano, francese, tedesco, spagnolo, italiano, portoghese e russo.",
    "faq2Q": "L'app richiede una connessione Internet?",
    "faq2A": "Si consiglia una connessione Internet stabile per la migliore esperienza, ma la visualizzazione di base della mappa stellare funziona offline dopo il download iniziale dei dati.",
    "faq3Q": "Star Wander è completamente gratuito?",
    "faq3A": "Star Wander è gratuito da scaricare con funzionalità di base disponibili gratuitamente. L'abbonamento premium sblocca il catalogo Messier completo, oltre 2,5 milioni di stelle dal Secondo Catalogo di Star Valley e la simulazione del campo visivo.",
    "faq4Q": "Quali dispositivi sono supportati?",
    "faq4A": "Star Wander è disponibile su dispositivi iOS (iPhone e iPad) e Android. Si consigliano dispositivi con iOS 17+ o Android 10+ per prestazioni ottimali.",
    "faq5Q": "Quanto è preciso il tracciamento stellare?",
    "faq5A": "Star Wander utilizza algoritmi astronomici precisi con dati dei principali cataloghi stellari. La precisione è al livello di secondi d'arco per il posizionamento degli oggetti celesti.",
    "ctaSubtitle": "Inizia il tuo viaggio",
    "ctaTitle1": "Pronto a esplorare",
    "ctaTitle2": "l'Universo?",
    "ctaDesc": "Punta il tuo dispositivo verso il cielo e scopri un universo di meraviglie — nessun telescopio necessario.",
    "ctaBtnAppStore": "Scarica su App Store",
    "ctaBtnGooglePlay": "Ottienilo su Google Play",
    "ctaFooter": "Download gratuito. Nessuna pubblicità. Nessun abbonamento richiesto.",
    "stat1": "Costellazioni",
    "stat2": "Utenti globali",
    "stat3": "Eventi / anno",
    "stat4": "Gratuito",
    "footerCopy": "Tutti i diritti riservati.",
    "userAgreement": "Termini di servizio",
    "privacyPolicy": "Politica sulla privacy",
    "androidSuffix": "(Android)",
    "iOSSuffix": "(iOS)"
  },
  "fr": {
    "languageName": "Français",
    "title": "Star Wander - Le ciel étoilé dans votre main",
    "appName": "Star Wander",
    "navFeatures": "Fonctionnalités",
    "navFaq": "FAQ",
    "navDownload": "Télécharger",
    "heroTitle": "Le ciel étoilé dans votre main",
    "heroSubtitle": "Explorez les étoiles, les planètes et les constellations en temps réel. Commencez votre voyage cosmique !",
    "downloadAppStore": "App Store",
    "downloadGooglePlay": "Google Play",
    "downloadHarmony": "App Gallery",
    "downloadApk": "Télécharger l'APK",
    "featuresTitle": "Fonctionnalités clés",
    "feature1Title": "Voyage Temporel",
    "feature1Desc": "Observez le ciel du passé ou du futur en un instant.",
    "feature2Title": "Guide d'Observation",
    "feature2Desc": "Identifiez les astres visibles ce soir avec précision.",
    "feature3Title": "Calendrier Astro",
    "feature3Desc": "Prévoyez les pluies de météores et les éclipses à venir.",
    "feature4Title": "Recherche Intelligente",
    "feature4Desc": "Localisez des cibles instantanément dans l'immensité spatiale.",
    "feature5Title": "Exploration",
    "feature5Desc": "Touchez un astre pour déverrouiller une base de connaissances.",
    "faqTitle": "Questions Fréquentes",
    "faq1Q": "Quelles langues Star Wander prend-il en charge ?",
    "faq1A": "Star Wander prend en charge plus de 10 langues, dont l'anglais, le chinois (simplifié et traditionnel), le japonais, le coréen, le français, l'allemand, l'espagnol, l'italien, le portugais et le russe.",
    "faq2Q": "L'application nécessite-t-elle une connexion Internet ?",
    "faq2A": "Une connexion Internet stable est recommandée pour une expérience optimale, mais l'affichage de base de la carte stellaire fonctionne hors ligne après le téléchargement initial des données.",
    "faq3Q": "Star Wander est-il complètement gratuit ?",
    "faq3A": "Star Wander est gratuit à télécharger avec des fonctionnalités de base disponibles sans frais. L'abonnement premium débloque le catalogue Messier complet, plus de 2,5 millions d'étoiles du Second Catalogue Star Valley, et la simulation du champ de vision.",
    "faq4Q": "Quels appareils sont pris en charge ?",
    "faq4A": "Star Wander est disponible sur les appareils iOS (iPhone et iPad) et Android. Nous recommandons les appareils sous iOS 17+ ou Android 10+ pour des performances optimales.",
    "faq5Q": "Quelle est la précision du suivi des étoiles ?",
    "faq5A": "Star Wander utilise des algorithmes astronomiques précis avec des données provenant des principaux catalogues d'étoiles. La précision est de l'ordre de la seconde d'arc pour le positionnement des objets célestes.",
    "ctaSubtitle": "Commencez votre voyage",
    "ctaTitle1": "Prêt à explorer",
    "ctaTitle2": "l'Univers ?",
    "ctaDesc": "Pointez votre appareil vers le ciel et découvrez un univers de merveilles — aucun télescope nécessaire.",
    "ctaBtnAppStore": "Télécharger sur l'App Store",
    "ctaBtnGooglePlay": "Obtenir sur Google Play",
    "ctaFooter": "Téléchargement gratuit. Sans publicité. Aucun abonnement requis.",
    "stat1": "Constellations",
    "stat2": "Utilisateurs mondiaux",
    "stat3": "Événements / an",
    "stat4": "Gratuit",
    "footerCopy": "Tous droits réservés.",
    "userAgreement": "Conditions d'utilisation",
    "privacyPolicy": "Politique de confidentialité",
    "androidSuffix": "(Android)",
    "iOSSuffix": "(iOS)"
  },
  "ru": {
    "languageName": "Русский",
    "title": "Star Wander - Звездное небо в вашей руке",
    "appName": "Star Wander",
    "navFeatures": "Функции",
    "navFaq": "FAQ",
    "navDownload": "Скачать",
    "heroTitle": "Звездное небо в вашей руке",
    "heroSubtitle": "Исследуйте звезды, планеты и созвездия в реальном времени. Начните свое космическое путешествие!",
    "downloadAppStore": "App Store",
    "downloadGooglePlay": "Google Play",
    "downloadHarmony": "App Gallery",
    "downloadApk": "Скачать Apk",
    "featuresTitle": "Ключевые функции",
    "feature1Title": "Сквозь время",
    "feature1Desc": "Наблюдайте за небом прошлого или будущего в любой момент.",
    "feature2Title": "Гид по звездам",
    "feature2Desc": "Узнайте, какие небесные тела видны сегодня вечером.",
    "feature3Title": "Астро-календарь",
    "feature3Desc": "Прогноз метеорных потоков и затмений в вашем кармане.",
    "feature4Title": "Умный поиск",
    "feature4Desc": "Мгновенно находите звезды и созвездия в небесном океане.",
    "feature5Title": "Исследование",
    "feature5Desc": "Коснитесь объекта, чтобы открыть базу знаний о космосе.",
    "faqTitle": "Часто задаваемые вопросы",
    "faq1Q": "Какие языки поддерживает Star Wander?",
    "faq1A": "Star Wander поддерживает более 10 языков, включая английский, китайский (упрощенный и традиционный), японский, корейский, французский, немецкий, испанский, итальянский, португальский и русский.",
    "faq2Q": "Требуется ли приложению подключение к Интернету?",
    "faq2A": "Стабильное интернет-соединение рекомендуется для наилучшего опыта, но базовый просмотр звездных карт работает офлайн после первоначальной загрузки данных.",
    "faq3Q": "Star Wander полностью бесплатен?",
    "faq3A": "Star Wander бесплатен для загрузки с бесплатными базовыми функциями. Премиум-подписка открывает полный каталог Мессье, более 2,5 миллионов звезд из Второго каталога Star Valley и симуляцию поля зрения.",
    "faq4Q": "Какие устройства поддерживаются?",
    "faq4A": "Star Wander доступен на устройствах iOS (iPhone и iPad) и Android. Рекомендуются устройства с iOS 17+ или Android 10+ для оптимальной производительности.",
    "faq5Q": "Насколько точно отслеживание звезд?",
    "faq5A": "Star Wander использует точные астрономические алгоритмы с данными из основных звездных каталогов. Точность позиционирования небесных объектов составляет доли угловой секунды.",
    "ctaSubtitle": "Начните свое путешествие",
    "ctaTitle1": "Готовы исследовать",
    "ctaTitle2": "Вселенную?",
    "ctaDesc": "Направьте устройство на небо и откройте вселенную чудес — телескоп не нужен.",
    "ctaBtnAppStore": "Загрузить в App Store",
    "ctaBtnGooglePlay": "Получить в Google Play",
    "ctaFooter": "Бесплатная загрузка. Без рекламы. Без подписки.",
    "stat1": "Созвездий",
    "stat2": "Пользователей",
    "stat3": "Событий / год",
    "stat4": "Бесплатно",
    "footerCopy": "Все права защищены.",
    "userAgreement": "Условия предоставления услуг",
    "privacyPolicy": "Политика конфиденциальности",
    "androidSuffix": "(Android)",
    "iOSSuffix": "(iOS)"
  },
  "ko": {
    "languageName": "한국어",
    "title": "Star Wander - 손 안의 별이 빛나는 하늘",
    "appName": "Star Wander",
    "navFeatures": "기능",
    "navFaq": "FAQ",
    "navDownload": "다운로드",
    "heroTitle": "손 안의 별이 빛나는 하늘",
    "heroSubtitle": "실시간으로 별, 행성, 별자리를 탐험하세요. 우주 여행을 시작하세요!",
    "downloadAppStore": "App Store",
    "downloadGooglePlay": "Google Play",
    "downloadHarmony": "App Gallery",
    "downloadApk": "Apk 다운로드",
    "featuresTitle": "주요 기능",
    "feature1Title": "시간 여행",
    "feature1Desc": "과거와 미래의 성상을 자유롭게 확인해 보세요.",
    "feature2Title": "관측 가이드",
    "feature2Desc": "오늘 밤 볼 수 있는 천체를 스마트하게 안내해 드립니다.",
    "feature3Title": "천문 달력",
    "feature3Desc": "유성우와 월식 등 우주 쇼를 정확하게 예측합니다.",
    "feature4Title": "스마트 검색",
    "feature4Desc": "방대한 별바다에서 목표를 즉시 찾아내는 검색 엔진.",
    "feature5Title": "심층 탐사",
    "feature5Desc": "천체를 터치하여 상세한 천문 지식을 확인하세요.",
    "faqTitle": "자주 묻는 질문",
    "faq1Q": "Star Wander는 어떤 언어를 지원하나요?",
    "faq1A": "Star Wander는 영어, 중국어(간체 및 번체), 일본어, 한국어, 프랑스어, 독일어, 스페인어, 이탈리아어, 포르투갈어, 러시아어를 포함한 10개 이상의 언어를 지원합니다.",
    "faq2Q": "앱을 사용하려면 인터넷 연결이 필요한가요?",
    "faq2A": "최상의 경험을 위해 안정적인 인터넷 연결을 권장하지만, 초기 데이터 다운로드 후에는 기본 별자리 보기가 오프라인에서도 가능합니다.",
    "faq3Q": "Star Wander는 완전 무료인가요?",
    "faq3A": "Star Wander는 기본 기능을 무료로 다운로드하여 사용할 수 있습니다. 프리미엄 멤버십을 통해 완전한 메시에 천체 목록, Star Valley Second Catalog의 250만 개 이상의 별, 시야 시뮬레이션을 이용할 수 있습니다.",
    "faq4Q": "어떤 기기를 지원하나요?",
    "faq4A": "Star Wander는 iOS(iPhone 및 iPad) 및 Android 기기에서 사용할 수 있습니다. 최적의 성능을 위해 iOS 17+ 또는 Android 10+ 기기를 권장합니다.",
    "faq5Q": "별 추적의 정확도는 어느 정도인가요?",
    "faq5A": "Star Wander는 주요 별 카탈로그의 데이터를 사용한 정밀한 천문 알고리즘을 사용합니다. 천체 위치 정확도는 초각 수준입니다.",
    "ctaSubtitle": "여정을 시작하세요",
    "ctaTitle1": "우주를 탐험할",
    "ctaTitle2": "준비가 되셨나요?",
    "ctaDesc": "기기를 하늘에 대고 망원경 없이 우주의 경이로움을 발견하세요.",
    "ctaBtnAppStore": "App Store에서 다운로드",
    "ctaBtnGooglePlay": "Google Play에서 받기",
    "ctaFooter": "무료 다운로드. 광고 없음. 구독 불필요.",
    "stat1": "별자리",
    "stat2": "전체 사용자",
    "stat3": "연간 이벤트",
    "stat4": "완전 무료",
    "footerCopy": "모든 권리 보유.",
    "userAgreement": "이용 약관",
    "privacyPolicy": "개인정보처리방침",
    "androidSuffix": "(안드로이드)",
    "iOSSuffix": "(iOS)"
  },
  "es": {
    "languageName": "Español",
    "title": "Star Wander - El cielo estrellado en tu mano",
    "appName": "Star Wander",
    "navFeatures": "Características",
    "navFaq": "FAQ",
    "navDownload": "Descargar",
    "heroTitle": "El cielo estrellado en tu mano",
    "heroSubtitle": "Explora estrellas, planetas y constelaciones en tiempo real. ¡Comienza tu viaje cósmico!",
    "downloadAppStore": "App Store",
    "downloadGooglePlay": "Google Play",
    "downloadHarmony": "App Gallery",
    "downloadApk": "Descargar Apk",
    "featuresTitle": "Características principales",
    "feature1Title": "Viaje en el Tiempo",
    "feature1Desc": "Salta a cualquier momento para observar el cielo pasado o futuro.",
    "feature2Title": "Guía de Observación",
    "feature2Desc": "Identifica los astros visibles esta noche de forma inteligente.",
    "feature3Title": "Calendario Astro",
    "feature3Desc": "Predice lluvias de estrellas y eclipses sin perderte nada.",
    "feature4Title": "Búsqueda Rápida",
    "feature4Desc": "Localiza estrellas y constelaciones al instante en el cielo.",
    "feature5Title": "Exploración",
    "feature5Desc": "Toca cualquier astro para ver su base de datos detallada.",
    "faqTitle": "Preguntas Frecuentes",
    "faq1Q": "¿Qué idiomas soporta Star Wander?",
    "faq1A": "Star Wander soporta más de 10 idiomas, incluyendo inglés, chino (simplificado y tradicional), japonés, coreano, francés, alemán, español, italiano, portugués y ruso.",
    "faq2Q": "¿La aplicación requiere conexión a Internet?",
    "faq2A": "Se recomienda una conexión a Internet estable para la mejor experiencia, pero la visualización básica de mapas estelares funciona sin conexión después de la descarga inicial de datos.",
    "faq3Q": "¿Star Wander es completamente gratuito?",
    "faq3A": "Star Wander es gratuito para descargar con funciones básicas disponibles sin costo. La suscripción premium desbloquea el catálogo Messier completo, más de 2,5 millones de estrellas del Segundo Catálogo Star Valley y la simulación del campo de visión.",
    "faq4Q": "¿Qué dispositivos son compatibles?",
    "faq4A": "Star Wander está disponible en dispositivos iOS (iPhone y iPad) y Android. Recomendamos dispositivos con iOS 17+ o Android 10+ para un rendimiento óptimo.",
    "faq5Q": "¿Qué tan preciso es el seguimiento de estrellas?",
    "faq5A": "Star Wander utiliza algoritmos astronómicos precisos con datos de los principales catálogos estelares. La precisión es de nivel de arco-segundo para el posicionamiento de objetos celestes.",
    "ctaSubtitle": "Comienza tu viaje",
    "ctaTitle1": "Listo para explorar",
    "ctaTitle2": "el Universo?",
    "ctaDesc": "Apunta tu dispositivo al cielo y descubre un universo de maravillas — no necesitas telescopio.",
    "ctaBtnAppStore": "Descargar en App Store",
    "ctaBtnGooglePlay": "Consíguelo en Google Play",
    "ctaFooter": "Descarga gratuita. Sin anuncios. Sin suscripción.",
    "stat1": "Constelaciones",
    "stat2": "Usuarios globales",
    "stat3": "Eventos / año",
    "stat4": "Gratuito",
    "footerCopy": "Todos los derechos reservados.",
    "userAgreement": "Términos de servicio",
    "privacyPolicy": "Política de privacidad",
    "androidSuffix": "(Android)",
    "iOSSuffix": "(iOS)"
  },
  "de": {
    "languageName": "Deutsch",
    "title": "Star Wander - Der Sternenhimmel in deiner Hand",
    "appName": "Star Wander",
    "navFeatures": "Funktionen",
    "navFaq": "FAQ",
    "navDownload": "Herunterladen",
    "heroTitle": "Der Sternenhimmel in deiner Hand",
    "heroSubtitle": "Erkunde Sterne, Planeten und Sternbilder in Echtzeit. Beginne deine kosmische Reise!",
    "downloadAppStore": "App Store",
    "downloadGooglePlay": "Google Play",
    "downloadHarmony": "App Gallery",
    "downloadApk": "Apk herunterladen",
    "featuresTitle": "Funktionen",
    "feature1Title": "Zeitreise",
    "feature1Desc": "Beobachten Sie den Himmel der Vergangenheit oder Zukunft.",
    "feature2Title": "Beobachtungshilfe",
    "feature2Desc": "Finden Sie heraus, welche Himmelskörper heute sichtbar sind.",
    "feature3Title": "Astro-Kalender",
    "feature3Desc": "Präzise Vorhersage von Meteorströmen und Finsternissen.",
    "feature4Title": "Intelligente Suche",
    "feature4Desc": "Sterne und Sternbilder im Handumdrehen lokalisieren.",
    "feature5Title": "Erkundung",
    "feature5Desc": "Tippen Sie auf Sterne für detailliertes astronomisches Wissen.",
    "faqTitle": "Häufig gestellte Fragen",
    "faq1Q": "Welche Sprachen unterstützt Star Wander?",
    "faq1A": "Star Wander unterstützt über 10 Sprachen, darunter Englisch, Chinesisch (vereinfacht und traditionell), Japanisch, Koreanisch, Französisch, Deutsch, Spanisch, Italienisch, Portugiesisch und Russisch.",
    "faq2Q": "Benötigt die App eine Internetverbindung?",
    "faq2A": "Eine stabile Internetverbindung wird für das beste Erlebnis empfohlen, aber die grundlegende Sternkartenansicht funktioniert nach dem ersten Datendownload auch offline.",
    "faq3Q": "Ist Star Wander komplett kostenlos?",
    "faq3A": "Star Wander ist kostenlos herunterladbar mit grundlegenden Funktionen. Das Premium-Abonnement schaltet den vollständigen Messier-Katalog, über 2,5 Millionen Sterne aus dem Star Valley Second Catalog und die Sichtfeldsimulation frei.",
    "faq4Q": "Welche Geräte werden unterstützt?",
    "faq4A": "Star Wander ist auf iOS (iPhone und iPad) und Android-Geräten verfügbar. Wir empfehlen Geräte mit iOS 17+ oder Android 10+ für optimale Leistung.",
    "faq5Q": "Wie genau ist die Sternverfolgung?",
    "faq5A": "Star Wander verwendet präzise astronomische Algorithmen mit Daten aus bedeutenden Sternkatalogen. Die Genauigkeit liegt im Bogensekundenbereich für die Positionierung von Himmelsobjekten.",
    "ctaSubtitle": "Beginne deine Reise",
    "ctaTitle1": "Bereit, das",
    "ctaTitle2": "Universum zu erkunden?",
    "ctaDesc": "Richten Sie Ihr Gerät gen Himmel und entdecken Sie ein Universum voller Wunder — kein Teleskop erforderlich.",
    "ctaBtnAppStore": "Im App Store herunterladen",
    "ctaBtnGooglePlay": "Bei Google Play herunterladen",
    "ctaFooter": "Kostenloser Download. Keine Werbung. Kein Abo erforderlich.",
    "stat1": "Sternbilder",
    "stat2": "Weltweite Nutzer",
    "stat3": "Ereignisse / Jahr",
    "stat4": "Kostenlos",
    "footerCopy": "Alle Rechte vorbehalten.",
    "userAgreement": "Nutzungsbedingungen",
    "privacyPolicy": "Datenschutzbestimmungen",
    "androidSuffix": "(Android)",
    "iOSSuffix": "(iOS)"
  },
  "pt": {
    "languageName": "Português",
    "title": "Star Wander - O céu estrelado na sua mão",
    "appName": "Star Wander",
    "navFeatures": "Recursos",
    "navFaq": "FAQ",
    "navDownload": "Baixar",
    "heroTitle": "O céu estrelado na sua mão",
    "heroSubtitle": "Explore estrelas, planetas e constelações em tempo real. Comece sua jornada cósmica!",
    "downloadAppStore": "App Store",
    "downloadGooglePlay": "Google Play",
    "downloadHarmony": "App Gallery",
    "downloadApk": "Baixar Apk",
    "featuresTitle": "Recursos principais",
    "feature1Title": "Viagem no Tempo",
    "feature1Desc": "Observe o céu do passado ou do futuro em qualquer instante.",
    "feature2Title": "Guia de Observação",
    "feature2Desc": "Identifique astros visíveis hoje à noite de forma inteligente.",
    "feature3Title": "Calendário Astro",
    "feature3Desc": "Previsão de chuvas de meteoros e eclipses imperdíveis.",
    "feature4Title": "Busca Inteligente",
    "feature4Desc": "Localize estrelas e constelações instantaneamente no céu.",
    "feature5Title": "Exploração Profunda",
    "feature5Desc": "Toque nos astros para acessar uma base de dados detalhada.",
    "faqTitle": "Perguntas Frequentes",
    "faq1Q": "Quais idiomas o Star Wander suporta?",
    "faq1A": "O Star Wander suporta mais de 10 idiomas, incluindo inglês, chinês (simplificado e tradicional), japonês, coreano, francês, alemão, espanhol, italiano, português e russo.",
    "faq2Q": "O aplicativo precisa de conexão com a internet?",
    "faq2A": "Recomenda-se uma conexão de internet estável para a melhor experiência, mas a visualização básica do mapa estelar funciona offline após o download inicial dos dados.",
    "faq3Q": "O Star Wander é completamente gratuito?",
    "faq3A": "O Star Wander é gratuito para baixar com funcionalidades básicas disponíveis sem custo. A assinatura premium desbloqueia o catálogo Messier completo, mais de 2,5 milhões de estrelas do Second Star Valley Catalog e a simulação de campo de visão.",
    "faq4Q": "Quais dispositivos são suportados?",
    "faq4A": "O Star Wander está disponível em dispositivos iOS (iPhone e iPad) e Android. Recomendamos dispositivos com iOS 17+ ou Android 10+ para desempenho ideal.",
    "faq5Q": "Quão preciso é o rastreamento de estrelas?",
    "faq5A": "O Star Wander usa algoritmos astronômicos precisos com dados dos principais catálogos de estrelas. A precisão é de nível de arco-segundo para o posicionamento de objetos celestes.",
    "ctaSubtitle": "Comece sua jornada",
    "ctaTitle1": "Pronto para explorar",
    "ctaTitle2": "o Universo?",
    "ctaDesc": "Aponte seu dispositivo para o céu e descubra um universo de maravilhas — sem necessidade de telescópio.",
    "ctaBtnAppStore": "Baixar na App Store",
    "ctaBtnGooglePlay": "Obter no Google Play",
    "ctaFooter": "Download gratuito. Sem anúncios. Sem assinatura.",
    "stat1": "Constelações",
    "stat2": "Usuários globais",
    "stat3": "Eventos / ano",
    "stat4": "Gratuito",
    "footerCopy": "Todos os direitos reservados.",
    "userAgreement": "Termos de Serviço",
    "privacyPolicy": "Política de Privacidade",
    "androidSuffix": "(Android)",
    "iOSSuffix": "(iOS)"
  }
};